import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "sprod" }
const _hoisted_2 = { class: "sprod__work" }
const _hoisted_3 = { class: "sui-card sui-card--flush sprod__catalog" }
const _hoisted_4 = {
  class: "sprod__cond",
  "data-tour": "seller-products-toolbar"
}
const _hoisted_5 = { class: "sprod__cond-head" }
const _hoisted_6 = { class: "sprod__cond-caption" }
const _hoisted_7 = {
  class: "sprod__filters",
  role: "toolbar",
  "aria-label": "상태"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "sprod__cond-grid" }
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = { value: "low" }
const _hoisted_14 = { class: "sprod__search-line" }
const _hoisted_15 = { class: "sui-search" }
const _hoisted_16 = { class: "sprod__cond-tools" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "sprod__error"
}
const _hoisted_20 = {
  key: 1,
  class: "sprod__list",
  "data-tour": "seller-products-table"
}
const _hoisted_21 = { class: "sprod__list-head" }
const _hoisted_22 = ["checked"]
const _hoisted_23 = ["aria-pressed", "onClick", "onKeydown"]
const _hoisted_24 = ["value", "aria-label"]
const _hoisted_25 = { class: "sprod__cell sprod__cell--prod" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "sprod__name" }
const _hoisted_28 = { class: "sprod__meta" }
const _hoisted_29 = { class: "sprod__cell sprod__cell--price" }
const _hoisted_30 = { class: "sprod__tags" }
const _hoisted_31 = { class: "sprod__cell sprod__cell--mall" }
const _hoisted_32 = { class: "sprod__cell sprod__cell--status" }
const _hoisted_33 = {
  key: 2,
  class: "sprod__empty"
}
const _hoisted_34 = ["aria-label"]
const _hoisted_35 = {
  key: 0,
  class: "sprod__pick",
  "data-tour": "seller-products-bulk"
}
const _hoisted_36 = { class: "sprod__pick-list" }
const _hoisted_37 = { class: "sprod__pick-actions" }
const _hoisted_38 = {
  key: 4,
  class: "sprod__pick-none"
}
const _hoisted_39 = {
  key: 5,
  class: "sprod__pick-none"
}
const _hoisted_40 = { class: "sprod__focus-head" }
const _hoisted_41 = { class: "sprod__focus-mall" }
const _hoisted_42 = { class: "sprod__focus-id" }
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = {
  key: 0,
  class: "sprod__reason"
}
const _hoisted_45 = { class: "sprod__focus-price" }
const _hoisted_46 = { class: "sprod__focus-stats" }
const _hoisted_47 = ["aria-label"]
const _hoisted_48 = ["aria-label"]
const _hoisted_49 = ["aria-label"]
const _hoisted_50 = {
  class: "sprod__focus-status",
  "data-tour": "seller-products-mall-live"
}
const _hoisted_51 = ["value", "aria-label"]
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "sprod__focus-now" }
const _hoisted_54 = ["disabled", "aria-label"]
const _hoisted_55 = ["disabled", "aria-label"]
const _hoisted_56 = { class: "sprod__focus-actions" }
const _hoisted_57 = {
  class: "sprod__focus-more",
  "data-tour": "seller-products-clone"
}
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["href"]
const _hoisted_60 = {
  key: 2,
  class: "sprod__bench-empty"
}
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 2 }
const _hoisted_64 = {
  key: 0,
  class: "sui-toast"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import ManageProductStorefrontModal from '@/components/manage/ManageProductStorefrontModal.vue'
import ProductRatingModal from '@/components/manage/ProductRatingModal.vue'
import ProductStockHistoryModal from '@/components/manage/ProductStockHistoryModal.vue'
import ProductViewsInsightModal from '@/components/manage/ProductViewsInsightModal.vue'
import SellerProductFormModal from '@/components/seller/SellerProductFormModal.vue'
import { confirmDialog } from '@/composables/useConfirmDialog'
import { useSellerProducts } from '@/composables/useSellerProducts'
import { mallProductPath } from '@/constants/mall'
import {
  createSellerProduct,
  fetchSellerProduct,
  MALL_PRODUCT_STATUS_LABEL,
  isMallLiveStatus,
  mallLiveLabel,
  type MallProductStatus,
} from '@/api/mallProduct'
import {
  createProductForm,
  hydrateProductForm,
  marginOf,
  toProductPayload,
  type MarginBreakdown,
} from '@/constants/productEditor'
import { LOW_STOCK_THRESHOLD, formatWon } from '@/constants/sellerData'
import { csvEscape } from '@/utils/csv'

type MallFilter = 'REGULAR' | 'SALE'
type MallScope = 'all' | MallFilter

interface ProductRow {
  id: string
  name: string
  image: string
  mallKind: MallFilter
  category: string
  price: number
  cost: number
  margin: MarginBreakdown
  stock: number
  status: MallProductStatus
  approved: boolean
  rejectReason: string
  createdAt: string
  soldCount: number
  views: number
  rating: number
  reviewCount: number
}

type StatusFilter = MallProductStatus | 'all'


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerProductsPage',
  setup(__props) {

const LIVE_STATUS_OPTIONS: MallProductStatus[] = ['SELLING', 'SOLDOUT', 'HIDDEN']

const {
  products: liveProducts,
  loading,
  errorMessage,
  load,
  upsert,
  changeStatus,
  remove,
} = useSellerProducts()

const route = useRoute()
const router = useRouter()
const statusFilter = ref<StatusFilter>('all')
const stockFilter = ref<'all' | 'low'>(String(route.query.stock || '') === 'low' ? 'low' : 'all')
const mallFilter = ref<MallScope>(
  route.query.mall === 'regular' ? 'REGULAR' : route.query.mall === 'group' ? 'SALE' : 'all',
)
const keyword = ref('')
const category = ref<string>('all')
const sortKey = ref<'sold' | 'stockAsc' | 'priceDesc' | 'newest'>('newest')
const selected = ref<string[]>([])
const focusId = ref('')
const formOpen = ref(false)
const formCode = ref('')
const previewCode = ref('')
const previewMallOpen = ref(false)
const previewTab = ref<'detail' | 'review' | 'qna' | 'shipping'>('detail')
const cloningId = ref('')
const stockHistoryCode = ref('')
const stockHistoryName = ref('')
const ratingInsight = ref<{
  code: string
  name: string
  rating: number
  reviewCount: number
} | null>(null)
const viewsInsight = ref<{
  code: string
  name: string
  views: number
  soldCount: number
  mallOpen: boolean
} | null>(null)
const toast = ref('')
let toastTimer: ReturnType<typeof setTimeout> | undefined

function openPreview(row: ProductRow, tab: 'detail' | 'review' | 'qna' | 'shipping' = 'detail') {
  previewTab.value = tab
  previewCode.value = row.id
  previewMallOpen.value = isPublic(row)
}

function closePreview() {
  previewCode.value = ''
  previewMallOpen.value = false
  previewTab.value = 'detail'
}

function openRating(row: ProductRow) {
  viewsInsight.value = null
  stockHistoryCode.value = ''
  stockHistoryName.value = ''
  ratingInsight.value = {
    code: row.id,
    name: row.name,
    rating: row.rating,
    reviewCount: row.reviewCount,
  }
  if (route.query.panel === 'views' || route.query.panel === 'stock' || route.query.code) {
    router.replace({ path: '/seller/products', query: pageQuery({ panel: undefined, code: undefined }) })
  }
}

function openViewsInsight(row: ProductRow) {
  ratingInsight.value = null
  viewsInsight.value = {
    code: row.id,
    name: row.name,
    views: row.views,
    soldCount: row.soldCount,
    mallOpen: isPublic(row),
  }
  if (route.query.panel === 'stock' || route.query.code) {
    stockHistoryCode.value = ''
    stockHistoryName.value = ''
    router.replace({
      path: '/seller/products',
      query: pageQuery({
        panel: route.query.panel === 'views' ? 'views' : undefined,
        code: undefined,
      }),
    })
  }
}

const viewsMenuOpen = computed(() => route.query.panel === 'views')
const stockMenuOpen = computed(() => route.query.panel === 'stock')

function closeViews() {
  viewsInsight.value = null
  if (route.query.panel === 'views') {
    router.replace({ path: '/seller/products', query: pageQuery({ panel: undefined }) })
  }
}

function onPickViews(code: string) {
  const row = rows.value.find((item) => item.id === code)
  if (!row) {
    viewsInsight.value = null
    return
  }
  openViewsInsight(row)
}

function onPickStock(code: string) {
  const row = rows.value.find((item) => item.id === code)
  if (!row) {
    stockHistoryCode.value = ''
    stockHistoryName.value = ''
    return
  }
  openStockHistory(row)
}

function openPreviewFromViews() {
  const item = viewsInsight.value
  if (!item) return
  viewsInsight.value = null
  previewTab.value = 'detail'
  previewCode.value = item.code
  previewMallOpen.value = item.mallOpen
  if (route.query.panel === 'views') {
    router.replace({ path: '/seller/products', query: pageQuery({ panel: undefined }) })
  }
}

function mallLabel(kind: MallFilter): string {
  return kind === 'REGULAR' ? '상시몰' : '공동구매몰'
}

function pageQuery(patch: Record<string, string | undefined> = {}) {
  const query: Record<string, string> = {}
  if (mallFilter.value === 'REGULAR') query.mall = 'regular'
  else if (mallFilter.value === 'SALE') query.mall = 'group'
  if (stockFilter.value === 'low') query.stock = 'low'
  if (route.query.panel) query.panel = String(route.query.panel)
  if (route.query.form) query.form = String(route.query.form)
  if (route.query.code) query.code = String(route.query.code)
  for (const [key, value] of Object.entries(patch)) {
    if (!value) delete query[key]
    else query[key] = value
  }
  return query
}

function setMall(kind: MallScope) {
  if (mallFilter.value === kind) return
  mallFilter.value = kind
  selected.value = []
  category.value = 'all'
  router.replace({ path: '/seller/products', query: pageQuery() })
}

function onMallChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value
  setMall(value === 'REGULAR' || value === 'SALE' ? value : 'all')
}

function onStockFilter(event: Event) {
  const value = (event.target as HTMLSelectElement).value
  stockFilter.value = value === 'low' ? 'low' : 'all'
  router.replace({ path: '/seller/products', query: pageQuery() })
}

function resetConditions() {
  statusFilter.value = 'all'
  stockFilter.value = 'all'
  category.value = 'all'
  keyword.value = ''
  sortKey.value = 'newest'
  if (mallFilter.value !== 'all') {
    setMall('all')
    return
  }
  router.replace({ path: '/seller/products', query: pageQuery() })
}

function openStockHistory(row: ProductRow) {
  ratingInsight.value = null
  stockHistoryCode.value = row.id
  stockHistoryName.value = row.name
  viewsInsight.value = null
  router.replace({
    path: '/seller/products',
    query: pageQuery({
      code: row.id,
      panel: route.query.panel === 'stock' ? 'stock' : undefined,
    }),
  })
}

function onStockUpdated(payload: { code: string; stock: number; status?: string }) {
  const row = rows.value.find((item) => item.id === payload.code)
  if (!row) return
  row.stock = payload.stock
  if (payload.status) row.status = payload.status as MallProductStatus
  notify(`재고 ${payload.stock.toLocaleString('ko-KR')}개로 반영했습니다.`)
}

function syncFormQuery() {
  const raw = String(route.query.form ?? '').trim()
  if (!raw) {
    formOpen.value = false
    formCode.value = ''
    return
  }
  if (raw === 'new') {
    formOpen.value = true
    formCode.value = ''
    return
  }
  formOpen.value = true
  formCode.value = raw
}

function openForm(code = '') {
  router.replace({ path: '/seller/products', query: pageQuery({ form: code || 'new' }) })
}

function closeForm() {
  router.replace({ path: '/seller/products', query: pageQuery({ form: undefined }) })
}

async function onFormSaved(code: string) {
  closeForm()
  await load(true)
  const saved = liveProducts.value.find((row) => row.code === code)
  const kind: MallFilter = saved?.mallKind === 'REGULAR' ? 'REGULAR' : 'SALE'
  if (saved && mallFilter.value !== 'all' && kind !== mallFilter.value) setMall(kind)
}

onMounted(async () => {
  syncFormQuery()
  await load()
  syncStockQuery()
})

watch(
  () => route.query.form,
  () => syncFormQuery(),
)

watch(
  () => String(route.query.panel || ''),
  (panel, prev) => {
    if (prev === 'views' && panel !== 'views') viewsInsight.value = null
    if (panel === 'views') {
      stockHistoryCode.value = ''
      stockHistoryName.value = ''
    }
  },
)

watch(
  () => route.query.mall,
  (value) => {
    if (value === 'regular') mallFilter.value = 'REGULAR'
    else if (value === 'group') mallFilter.value = 'SALE'
    else mallFilter.value = 'all'
  },
)

watch(
  () => [route.query.stock, route.query.code],
  () => syncStockQuery(),
)

function syncStockQuery() {
  stockFilter.value = String(route.query.stock || '') === 'low' ? 'low' : 'all'
  const code = String(route.query.code || '').trim()
  if (!code) return
  stockHistoryCode.value = code
  const found = liveProducts.value.find((row) => row.code === code)
  stockHistoryName.value = found?.name || ''
}

function closeStockHistory() {
  stockHistoryCode.value = ''
  stockHistoryName.value = ''
  if (route.query.code || route.query.panel === 'stock') {
    router.replace({
      path: '/seller/products',
      query: pageQuery({ code: undefined, panel: undefined }),
    })
  }
}

function reload() {
  selected.value = []
  load(true)
}

function notify(message: string) {
  toast.value = message
  window.clearTimeout(toastTimer)
  toastTimer = setTimeout(() => {
    toast.value = ''
  }, 2400)
}

const rows = computed<ProductRow[]>(() =>
  liveProducts.value.map((product) => ({
    id: product.code,
    name: product.name,
    image: product.thumbnail,
    mallKind: product.mallKind === 'REGULAR' ? 'REGULAR' : 'SALE',
    category: product.category,
    price: product.price,
    cost: product.cost ?? 0,
    margin: marginOf({
      price: product.price,
      cost: product.cost,
      marginShare: product.marginShare,
    }),
    stock: product.stock,
    status: product.status,
    approved: Boolean(product.reviewedAt || product.saleStartAt),
    rejectReason: product.status === 'REJECTED' ? product.rejectReason : '',
    createdAt: String(product.createdAt ?? '').slice(0, 10),
    soldCount: product.soldCount,
    views: product.viewCount,
    rating: product.rating,
    reviewCount: product.reviewCount,
  })),
)

const mallRows = computed(() =>
  mallFilter.value === 'all' ? rows.value : rows.value.filter((row) => row.mallKind === mallFilter.value),
)

const categories = computed(() => [...new Set(mallRows.value.map((row) => row.category))])

const lowCount = computed(() => mallRows.value.filter((row) => row.stock <= LOW_STOCK_THRESHOLD).length)

const hasCondition = computed(
  () =>
    statusFilter.value !== 'all' ||
    mallFilter.value !== 'all' ||
    category.value !== 'all' ||
    stockFilter.value !== 'all' ||
    keyword.value !== '' ||
    sortKey.value !== 'newest',
)

const summary = computed<Array<{ key: StatusFilter; label: string; count: number }>>(() => [
  { key: 'all', label: '전체', count: mallRows.value.length },
  { key: 'REQUESTED', label: '검수요청', count: mallRows.value.filter((row) => row.status === 'REQUESTED').length },
  { key: 'SELLING', label: '판매중', count: mallRows.value.filter((row) => row.status === 'SELLING').length },
  { key: 'SOLDOUT', label: '품절', count: mallRows.value.filter((row) => row.status === 'SOLDOUT').length },
  { key: 'REJECTED', label: '반려', count: mallRows.value.filter((row) => row.status === 'REJECTED').length },
  { key: 'HIDDEN', label: '숨김', count: mallRows.value.filter((row) => row.status === 'HIDDEN').length },
  { key: 'DRAFT', label: '임시저장', count: mallRows.value.filter((row) => row.status === 'DRAFT').length },
])

const filtered = computed(() => {
  const query = keyword.value.toLowerCase()

  const list = mallRows.value.filter((row) => {
    if (stockFilter.value === 'low' && row.stock > LOW_STOCK_THRESHOLD) return false
    if (statusFilter.value !== 'all' && row.status !== statusFilter.value) return false
    if (category.value !== 'all' && row.category !== category.value) return false
    if (query && !row.name.toLowerCase().includes(query)) return false
    return true
  })

  const sorted = [...list]
  switch (sortKey.value) {
    case 'sold':
      sorted.sort((a, b) => b.soldCount - a.soldCount)
      break
    case 'stockAsc':
      sorted.sort((a, b) => a.stock - b.stock)
      break
    case 'priceDesc':
      sorted.sort((a, b) => b.price - a.price)
      break
    default:
      sorted.sort((a, b) => b.createdAt.localeCompare(a.createdAt))
  }
  return sorted
})

const focused = computed(() => filtered.value.find((row) => row.id === focusId.value) || null)

watch(
  filtered,
  (list) => {
    const visible = new Set(list.map((row) => row.id))
    const nextSelected = selected.value.filter((id) => visible.has(id))
    if (nextSelected.length !== selected.value.length) selected.value = nextSelected
    if (list.some((row) => row.id === focusId.value)) return
    focusId.value = list[0]?.id || ''
  },
  { immediate: true },
)

const modalCandidates = computed(() =>
  filtered.value.map((row) => ({ code: row.id, name: row.name })),
)

const allChecked = computed(
  () => filtered.value.length > 0 && filtered.value.every((row) => selected.value.includes(row.id)),
)
const someChecked = computed(() => {
  const visible = filtered.value.filter((row) => selected.value.includes(row.id)).length
  return visible > 0 && visible < filtered.value.length
})
const allBox = ref<HTMLInputElement | null>(null)

watch([someChecked, allBox], () => {
  if (allBox.value) allBox.value.indeterminate = someChecked.value
})

function toggleAll() {
  selected.value = allChecked.value ? [] : filtered.value.map((row) => row.id)
}

function openRow(id: string) {
  selected.value = []
  focusId.value = id
}

function onRowKey(event: KeyboardEvent, id: string) {
  if (event.target !== event.currentTarget) return
  event.preventDefault()
  openRow(id)
}

function isPublic(row: ProductRow): boolean {
  return isMallLiveStatus(row.status)
}

function canToggleLiveStatus(row: ProductRow): boolean {
  return LIVE_STATUS_OPTIONS.includes(row.status)
}

const selectedRows = computed(() => rows.value.filter((row) => selected.value.includes(row.id)))
const requestableCount = computed(
  () => selectedRows.value.filter((row) => row.status === 'DRAFT' || row.status === 'REJECTED').length,
)
const withdrawableCount = computed(() => selectedRows.value.filter((row) => row.status === 'REQUESTED').length)
const selectedRequestable = computed(() => requestableCount.value > 0)
const selectedWithdrawable = computed(() => withdrawableCount.value > 0)
const resumeCount = computed(() => rowsForBulk('SELLING').length)
const stopCount = computed(() => rowsForBulk('HIDDEN').length)
const blockedResume = computed(
  () =>
    selectedRows.value.filter((row) => canToggleLiveStatus(row) && row.status !== 'SELLING' && row.stock <= 0)
      .length,
)
const hasBulkAction = computed(
  () => selectedRequestable.value || selectedWithdrawable.value || resumeCount.value > 0 || stopCount.value > 0,
)

watch(selected, (ids) => {
  if (ids.length === 1) focusId.value = ids[0]
})
const statusBusy = ref('')

function statusBadgeClass(status: MallProductStatus): string {
  if (status === 'REQUESTED') return 'sui-badge--violet'
  if (status === 'REJECTED') return 'sui-badge--red'
  if (status === 'DRAFT') return 'sui-badge--gray'
  return 'sui-badge--gray'
}

function reviewStatusNote(status: MallProductStatus): string {
  if (status === 'DRAFT') return '아직 검수를 요청하지 않았습니다.'
  if (status === 'REJECTED') return '반려된 상품입니다. 내용을 고친 뒤 다시 요청할 수 있습니다.'
  if (status === 'REQUESTED') return '검수를 요청해 둔 상태입니다. 결과를 기다리는 중입니다.'
  return ''
}

function downloadExcel() {
  const list = filtered.value
  if (!list.length) return

  const header = [
    '상품코드',
    '상품명',
    '판매몰',
    '카테고리',
    '판매가',
    '공급가',
    '판매업체마진',
    '재고',
    '상태',
    '몰노출',
    '판매수',
    '후기수',
    '평점',
  ]
  const body = list.map((row) =>
    [
      row.id,
      row.name,
      mallLabel(row.mallKind),
      row.category,
      String(row.price ?? ''),
      String(row.cost ?? ''),
      String(row.margin.seller ?? ''),
      String(row.stock ?? ''),
      MALL_PRODUCT_STATUS_LABEL[row.status] || row.status,
      mallLiveLabel(row.status),
      String(row.soldCount ?? ''),
      String(row.reviewCount ?? ''),
      String(row.rating ?? ''),
    ]
      .map((cell) => csvEscape(cell))
      .join(','),
  )
  const csv = `\uFEFF${[header.join(','), ...body].join('\n')}`
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `판매상품_${new Date().toISOString().slice(0, 10)}.csv`
  anchor.click()
  URL.revokeObjectURL(url)
}

async function onRequestReview(row: ProductRow) {
  if (statusBusy.value) return
  const again = row.status === 'REJECTED'
  if (
    !window.confirm(
      again
        ? `'${row.name}' 상품의 검수를 다시 요청할까요?`
        : `'${row.name}' 상품의 검수를 요청할까요? 요청 후 관리자 상품관리에 검수요청으로 보입니다.`,
    )
  ) {
    return
  }
  statusBusy.value = row.id
  try {
    await changeStatus(row.id, 'REQUESTED')
    notify(again ? '검수를 다시 요청했습니다.' : '검수를 요청했습니다.')
  } catch (error) {
    notify(error instanceof Error ? error.message : '검수를 요청하지 못했습니다.')
  } finally {
    statusBusy.value = ''
  }
}

async function onWithdrawReview(row: ProductRow) {
  if (statusBusy.value) return
  if (!window.confirm(`'${row.name}' 검수 요청을 철회하고 임시저장으로 되돌릴까요?`)) return
  statusBusy.value = row.id
  try {
    await changeStatus(row.id, 'DRAFT')
    notify('검수 요청을 철회했습니다.')
  } catch (error) {
    notify(error instanceof Error ? error.message : '검수 요청을 철회하지 못했습니다.')
  } finally {
    statusBusy.value = ''
  }
}

async function onStatus(row: ProductRow, event: Event) {
  const status = (event.target as HTMLSelectElement).value as MallProductStatus
  if (status === row.status) return
  if (!canToggleLiveStatus(row) || !LIVE_STATUS_OPTIONS.includes(status)) {
    notify('목록에서는 판매중·품절·숨김만 바꿀 수 있습니다. 검수 요청은 수정 화면에서 해 주세요.')
    await reload()
    return
  }
  if (
    !window.confirm(
      `'${row.name}' 판매상태를 '${MALL_PRODUCT_STATUS_LABEL[status]}'으로 바꿀까요?`,
    )
  ) {
    await reload()
    return
  }

  try {
    await changeStatus(row.id, status)
    notify(`판매상태를 '${MALL_PRODUCT_STATUS_LABEL[status]}'으로 바꿨습니다.`)
  } catch (error) {
    notify(error instanceof Error ? error.message : '판매상태를 바꾸지 못했습니다.')
    await reload()
  }
}

function rowsForBulk(status: MallProductStatus): ProductRow[] {
  return selectedRows.value.filter((row) => {
    if (status === 'REQUESTED') return row.status === 'DRAFT' || row.status === 'REJECTED'
    if (status === 'DRAFT') return row.status === 'REQUESTED'
    if (status === 'SELLING') return canToggleLiveStatus(row) && row.status !== 'SELLING' && row.stock > 0
    if (status === 'HIDDEN') return canToggleLiveStatus(row) && row.status !== 'HIDDEN'
    return false
  })
}

async function bulkStatus(status: MallProductStatus) {
  const targets = rowsForBulk(status)
  if (!targets.length) {
    notify(
      status === 'REQUESTED'
        ? '임시저장·반려 상품만 검수를 요청할 수 있습니다.'
        : status === 'DRAFT'
          ? '검수요청 상품만 철회할 수 있습니다.'
          : '판매중·품절·숨김 상품만 일괄로 바꿀 수 있습니다.',
    )
    return
  }
  const label =
    status === 'REQUESTED' ? '검수요청' : status === 'DRAFT' ? '임시저장' : MALL_PRODUCT_STATUS_LABEL[status]
  const skipped = selectedRows.value.length - targets.length
  const scope = skipped > 0 ? `바꿀 수 있는 ${targets.length}개` : `${targets.length}개`
  if (!window.confirm(`${scope} 상품을 '${label}'으로 바꿀까요?`)) return

  let done = 0
  let failed = ''
  for (const row of targets) {
    try {
      await changeStatus(row.id, status)
      done += 1
    } catch (error) {
      if (!failed) failed = error instanceof Error ? error.message : '일부 상품은 바꾸지 못했습니다.'
    }
  }

  notify(
    failed
      ? `${done}개를 바꿨습니다. ${failed}`
      : `${done}개 상품을 '${label}'으로 바꿨습니다.`,
  )
  selected.value = []
}

async function onDelete(row: ProductRow) {
  if (!window.confirm(`'${row.name}' 상품을 삭제할까요? 함우리몰에서도 내려갑니다.`)) {
    return
  }

  try {
    await remove(row.id)
    notify('상품을 삭제했습니다.')
  } catch (error) {
    notify(error instanceof Error ? error.message : '상품 삭제에 실패했습니다.')
  }
}

async function onClone(row: ProductRow) {
  if (cloningId.value) return

  const ok = await confirmDialog({
    title: '상품 복제',
    message: `'${row.name}'을(를) 복제해 임시저장 할까요?`,
    detail: '상품명에 「(복제)」가 붙고, 이미지는 기존 URL을 그대로 씁니다.',
    confirmLabel: '복제',
    tone: 'primary',
  })
  if (!ok) return

  cloningId.value = row.id
  try {
    const product = await fetchSellerProduct(row.id)
    const form = createProductForm({
      category: product.category,
      shippingFee: product.shippingFee,
      freeShipOver: 0,
    })
    hydrateProductForm(form, product)
    form.name = `${product.name} (복제)`
    form.requestNote = ''

    const created = await createSellerProduct(toProductPayload(form, 'DRAFT'))
    upsert(created)
    notify('복제한 상품을 임시저장했습니다.')
    openForm(created.code)
  } catch (error) {
    notify(error instanceof Error ? error.message : '상품 복제에 실패했습니다.')
  } finally {
    cloningId.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[24] || (_cache[24] = _createElementVNode("span", null, "상태", -1)),
              (hasCondition.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "sprod__cond-reset",
                    onClick: resetConditions
                  }, " 전체로 "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "sui-btn sui-btn--primary sprod__register",
              "data-tour": "seller-products-new",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openForm()))
            }, [
              _createVNode(AppIcon, {
                icon: "mdi-plus",
                size: 16
              }),
              _cache[25] || (_cache[25] = _createTextVNode(" 상품 등록 ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summary.value, (card) => {
              return (_openBlock(), _createElementBlock("button", {
                key: card.key,
                type: "button",
                class: _normalizeClass(["sprod__chip", { 'is-active': statusFilter.value === card.key }]),
                onClick: ($event: any) => (statusFilter.value = card.key)
              }, [
                _createTextVNode(_toDisplayString(card.label) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(card.count), 1)
              ], 10, _hoisted_8))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", {
              class: _normalizeClass(["sprod__field", { 'is-set': mallFilter.value !== 'all' }])
            }, [
              _cache[27] || (_cache[27] = _createElementVNode("span", null, "판매 몰", -1)),
              _createElementVNode("select", {
                class: "sui-select",
                "data-tour": "seller-products-mall",
                "aria-label": "판매 몰",
                value: mallFilter.value,
                onChange: onMallChange
              }, [...(_cache[26] || (_cache[26] = [
                _createElementVNode("option", { value: "all" }, "전체", -1),
                _createElementVNode("option", { value: "REGULAR" }, "상시몰", -1),
                _createElementVNode("option", { value: "SALE" }, "공동구매몰", -1)
              ]))], 40, _hoisted_10)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["sprod__field", { 'is-set': category.value !== 'all' }])
            }, [
              _cache[29] || (_cache[29] = _createElementVNode("span", null, "카테고리", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((category).value = $event)),
                class: "sui-select",
                "aria-label": "카테고리"
              }, [
                _cache[28] || (_cache[28] = _createElementVNode("option", { value: "all" }, "전체", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cat,
                    value: cat
                  }, _toDisplayString(cat), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, category.value]
              ])
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["sprod__field", { 'is-set': stockFilter.value !== 'all' }])
            }, [
              _cache[31] || (_cache[31] = _createElementVNode("span", null, "재고", -1)),
              _createElementVNode("select", {
                class: "sui-select",
                "aria-label": "재고",
                value: stockFilter.value,
                onChange: onStockFilter
              }, [
                _cache[30] || (_cache[30] = _createElementVNode("option", { value: "all" }, "전체", -1)),
                _createElementVNode("option", _hoisted_13, "저재고 " + _toDisplayString(lowCount.value), 1)
              ], 40, _hoisted_12)
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(["sprod__field", { 'is-set': sortKey.value !== 'newest' }])
            }, [
              _cache[33] || (_cache[33] = _createElementVNode("span", null, "정렬", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sortKey).value = $event)),
                class: "sui-select",
                "aria-label": "정렬"
              }, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("option", { value: "newest" }, "최근 등록순", -1),
                _createElementVNode("option", { value: "sold" }, "판매 많은순", -1),
                _createElementVNode("option", { value: "stockAsc" }, "재고 적은순", -1),
                _createElementVNode("option", { value: "priceDesc" }, "판매가 높은순", -1)
              ]))], 512), [
                [_vModelSelect, sortKey.value]
              ])
            ], 2),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass(["sprod__field sprod__field--search", { 'is-set': keyword.value !== '' }])
              }, [
                _cache[34] || (_cache[34] = _createElementVNode("span", null, "상품명", -1)),
                _createElementVNode("label", _hoisted_15, [
                  _createVNode(AppIcon, {
                    icon: "mdi-magnify",
                    size: 17
                  }),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((keyword).value = $event)),
                    type: "search",
                    placeholder: "상품명으로 찾기"
                  }, null, 512), [
                    [
                      _vModelText,
                      keyword.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ], 2),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn",
                  "data-tour": "seller-products-export",
                  disabled: !filtered.value.length,
                  onClick: downloadExcel
                }, [
                  _createVNode(AppIcon, {
                    icon: "mdi-download",
                    size: 16
                  }),
                  _cache[35] || (_cache[35] = _createTextVNode(" CSV ", -1))
                ], 8, _hoisted_17),
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn sui-btn--ghost",
                  disabled: _unref(loading),
                  "aria-label": "새로고침",
                  onClick: reload
                }, [
                  _createVNode(AppIcon, {
                    icon: "mdi-refresh",
                    size: 17
                  })
                ], 8, _hoisted_18)
              ])
            ])
          ])
        ]),
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
              _createVNode(AppIcon, {
                icon: "mdi-alert-outline",
                size: 16
              }),
              _createTextVNode(" " + _toDisplayString(_unref(errorMessage)), 1)
            ]))
          : _createCommentVNode("", true),
        (filtered.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("input", {
                  ref_key: "allBox",
                  ref: allBox,
                  type: "checkbox",
                  "aria-label": "전체 선택",
                  checked: allChecked.value,
                  onChange: toggleAll
                }, null, 40, _hoisted_22),
                _cache[36] || (_cache[36] = _createElementVNode("span", null, "상품", -1)),
                _cache[37] || (_cache[37] = _createElementVNode("span", null, "몰", -1)),
                _cache[38] || (_cache[38] = _createElementVNode("span", null, "판매가", -1)),
                _cache[39] || (_cache[39] = _createElementVNode("span", null, "재고", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("span", null, "상태", -1))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.id,
                  class: _normalizeClass(["sprod__row", {
            'is-focus': selected.value.length < 2 && focused.value?.id === row.id,
            'is-picked': selected.value.includes(row.id),
          }]),
                  role: "button",
                  tabindex: "0",
                  "aria-pressed": selected.value.length < 2 && focused.value?.id === row.id,
                  onClick: ($event: any) => (openRow(row.id)),
                  onKeydown: [
                    _withKeys(($event: any) => (onRowKey($event, row.id)), ["enter"]),
                    _withKeys(($event: any) => (onRowKey($event, row.id)), ["space"])
                  ]
                }, [
                  _createElementVNode("div", {
                    class: "sprod__cell sprod__cell--check",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: row.id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selected).value = $event)),
                      "aria-label": row.name
                    }, null, 8, _hoisted_24), [
                      [_vModelCheckbox, selected.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (row.image)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: row.image,
                          alt: row.name,
                          loading: "lazy"
                        }, null, 8, _hoisted_26))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(row.name), 1),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(row.id) + " · " + _toDisplayString(row.category), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(formatWon)(row.price)) + "원", 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["sprod__cell sprod__cell--stock", { 'is-low': row.stock <= _unref(LOW_STOCK_THRESHOLD) }])
                  }, _toDisplayString(_unref(formatWon)(row.stock)), 3),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sprod__mall-tag", row.mallKind === 'SALE' ? 'is-sale' : 'is-regular'])
                      }, _toDisplayString(mallLabel(row.mallKind)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-badge", statusBadgeClass(row.status)])
                      }, _toDisplayString(_unref(MALL_PRODUCT_STATUS_LABEL)[row.status]), 3)
                    ])
                  ])
                ], 42, _hoisted_23))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("p", null, _toDisplayString(_unref(loading)
              ? '상품을 불러오는 중입니다.'
              : rows.value.length
                ? '이 조건에 맞는 상품이 없습니다.'
                : '등록된 상품이 없습니다.'), 1),
              (!_unref(loading) && !_unref(errorMessage) && !rows.value.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "sui-btn sui-btn--primary",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (openForm()))
                  }, " 첫 상품 등록 "))
                : _createCommentVNode("", true)
            ]))
      ]),
      _createElementVNode("aside", {
        class: "sprod__bench",
        "data-tour": "seller-products-bench",
        "aria-label": selected.value.length > 1 ? `${selected.value.length}개 선택` : focused.value ? `${focused.value.name} 작업` : '상품 작업'
      }, [
        (selected.value.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _cache[41] || (_cache[41] = _createElementVNode("p", { class: "sprod__pick-kicker" }, "여러 상품", -1)),
              _createElementVNode("h2", null, _toDisplayString(selected.value.length) + "개 선택", 1),
              _cache[42] || (_cache[42] = _createElementVNode("p", { class: "sprod__pick-note" }, "상태만 한꺼번에 바꿉니다. 수정·미리보기·복제·삭제는 상품을 하나만 열 때 합니다.", -1)),
              _createElementVNode("ul", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRows.value, (row) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: row.id
                  }, [
                    _createElementVNode("span", null, _toDisplayString(row.name), 1),
                    _createElementVNode("em", null, _toDisplayString(_unref(MALL_PRODUCT_STATUS_LABEL)[row.status]), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_37, [
                (selectedRequestable.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "sui-btn sui-btn--block sui-btn--primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (bulkStatus('REQUESTED')))
                    }, " 검수 요청하기 " + _toDisplayString(requestableCount.value) + "개 ", 1))
                  : _createCommentVNode("", true),
                (selectedWithdrawable.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "sui-btn sui-btn--block",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (bulkStatus('DRAFT')))
                    }, " 요청 철회 " + _toDisplayString(withdrawableCount.value) + "개 ", 1))
                  : _createCommentVNode("", true),
                (resumeCount.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "sui-btn sui-btn--block",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (bulkStatus('SELLING')))
                    }, " 판매 재개 " + _toDisplayString(resumeCount.value) + "개 ", 1))
                  : _createCommentVNode("", true),
                (stopCount.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      type: "button",
                      class: "sui-btn sui-btn--block",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (bulkStatus('HIDDEN')))
                    }, " 판매 중지 " + _toDisplayString(stopCount.value) + "개 ", 1))
                  : _createCommentVNode("", true),
                (blockedResume.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, " 재고가 없는 " + _toDisplayString(blockedResume.value) + "개는 판매중으로 되돌리지 않습니다. 재고를 먼저 채우세요. ", 1))
                  : _createCommentVNode("", true),
                (!hasBulkAction.value && !blockedResume.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_39, " 이 선택에는 한꺼번에 바꿀 상태가 없습니다. "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn sui-btn--block sui-btn--ghost",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (selected.value = []))
                }, "선택 해제")
              ])
            ]))
          : (focused.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("header", _hoisted_40, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["sui-badge", statusBadgeClass(focused.value.status)])
                  }, _toDisplayString(_unref(MALL_PRODUCT_STATUS_LABEL)[focused.value.status]), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["sprod__live", { 'is-on': isPublic(focused.value) }])
                  }, _toDisplayString(_unref(mallLiveLabel)(focused.value.status)), 3),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(mallLabel(focused.value.mallKind)), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  (focused.value.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: focused.value.image,
                        alt: focused.value.name
                      }, null, 8, _hoisted_43))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", null, _toDisplayString(focused.value.name), 1),
                    _createElementVNode("p", null, _toDisplayString(focused.value.id) + " · " + _toDisplayString(focused.value.category), 1)
                  ])
                ]),
                (focused.value.rejectReason)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, "반려 사유 · " + _toDisplayString(focused.value.rejectReason), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_45, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", null, "판매가", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(focused.value.price)) + "원", 1)
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("button", {
                    type: "button",
                    "data-tour": "seller-products-views",
                    "aria-label": `${focused.value.name} 조회수 ${focused.value.views} · 전환 보기`,
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (openViewsInsight(focused.value)))
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-eye-outline",
                      size: 18
                    }),
                    _cache[44] || (_cache[44] = _createElementVNode("span", null, "조회", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(focused.value.views)), 1)
                  ], 8, _hoisted_47),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (openViewsInsight(focused.value)))
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-cart-outline",
                      size: 18
                    }),
                    _cache[45] || (_cache[45] = _createElementVNode("span", null, "판매", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_unref(formatWon)(focused.value.soldCount)), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    "data-tour": "seller-products-stock",
                    "aria-label": `${focused.value.name} 재고 ${focused.value.stock}개 · 이력 보기`,
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (openStockHistory(focused.value)))
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-warehouse",
                      size: 18
                    }),
                    _cache[46] || (_cache[46] = _createElementVNode("span", null, "재고", -1)),
                    _createElementVNode("strong", {
                      class: _normalizeClass({ 'is-low': focused.value.stock <= _unref(LOW_STOCK_THRESHOLD) })
                    }, _toDisplayString(_unref(formatWon)(focused.value.stock)), 3)
                  ], 8, _hoisted_48),
                  _createElementVNode("button", {
                    type: "button",
                    "data-tour": "seller-products-rating",
                    "aria-label": `${focused.value.name} 평점 ${focused.value.rating.toFixed(1)} · 후기 ${focused.value.reviewCount}건`,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (openRating(focused.value)))
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-star-outline",
                      size: 18
                    }),
                    _cache[47] || (_cache[47] = _createElementVNode("span", null, "평점", -1)),
                    _createElementVNode("strong", null, _toDisplayString(focused.value.rating.toFixed(1)), 1)
                  ], 8, _hoisted_49)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _cache[48] || (_cache[48] = _createElementVNode("p", { class: "sprod__focus-label" }, "상태", -1)),
                  (canToggleLiveStatus(focused.value))
                    ? (_openBlock(), _createElementBlock("select", {
                        key: 0,
                        class: "sui-select",
                        value: focused.value.status,
                        "aria-label": `${focused.value.name} 판매상태`,
                        onChange: _cache[16] || (_cache[16] = ($event: any) => (onStatus(focused.value, $event)))
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(LIVE_STATUS_OPTIONS, (option) => {
                          return _createElementVNode("option", {
                            key: option,
                            value: option
                          }, _toDisplayString(_unref(MALL_PRODUCT_STATUS_LABEL)[option]), 9, _hoisted_52)
                        }), 64))
                      ], 40, _hoisted_51))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["sui-badge", statusBadgeClass(focused.value.status)])
                          }, _toDisplayString(_unref(MALL_PRODUCT_STATUS_LABEL)[focused.value.status]), 3),
                          _createElementVNode("p", null, _toDisplayString(reviewStatusNote(focused.value.status)), 1)
                        ]),
                        (focused.value.status === 'DRAFT' || focused.value.status === 'REJECTED')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "sui-btn sui-btn--block sui-btn--primary",
                              disabled: statusBusy.value === focused.value.id,
                              "aria-label": `${focused.value.name} ${focused.value.status === 'REJECTED' ? '검수 다시 요청하기' : '검수 요청하기'}. 현재 상태는 ${_unref(MALL_PRODUCT_STATUS_LABEL)[focused.value.status]}입니다.`,
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (onRequestReview(focused.value)))
                            }, _toDisplayString(statusBusy.value === focused.value.id ? '요청 중…' : focused.value.status === 'REJECTED' ? '검수 다시 요청하기' : '검수 요청하기'), 9, _hoisted_54))
                          : (focused.value.status === 'REQUESTED')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "sui-btn sui-btn--block",
                                disabled: statusBusy.value === focused.value.id,
                                "aria-label": `${focused.value.name} 검수 요청 철회. 현재 상태는 검수요청입니다.`,
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (onWithdrawReview(focused.value)))
                              }, _toDisplayString(statusBusy.value === focused.value.id ? '철회 중…' : '요청 철회'), 9, _hoisted_55))
                            : _createCommentVNode("", true)
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["sui-btn sui-btn--block", { 'sui-btn--primary': canToggleLiveStatus(focused.value) }]),
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (openForm(focused.value.id)))
                  }, " 수정 ", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: "sui-btn sui-btn--block",
                    "data-tour": "seller-products-preview",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (openPreview(focused.value)))
                  }, " 몰 미리보기 "),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "sui-btn sui-btn--ghost",
                      disabled: cloningId.value === focused.value.id,
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (onClone(focused.value)))
                    }, _toDisplayString(cloningId.value === focused.value.id ? '복제 중…' : '복제'), 9, _hoisted_58),
                    (isPublic(focused.value))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "sui-btn sui-btn--ghost",
                          href: _unref(mallProductPath)(focused.value.id),
                          target: "_blank",
                          rel: "noopener"
                        }, " 몰에서 보기 ", 8, _hoisted_59))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "sui-btn sui-btn--ghost is-danger",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (onDelete(focused.value)))
                    }, "삭제")
                  ])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                (_unref(loading))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_61, "상품을 불러오는 중입니다."))
                  : (!rows.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_62, "등록된 상품이 없습니다. 상품 등록으로 시작합니다."))
                    : (_openBlock(), _createElementBlock("p", _hoisted_63, "이 조건에 맞는 상품이 없습니다."))
              ]))
      ], 8, _hoisted_34)
    ]),
    (formOpen.value)
      ? (_openBlock(), _createBlock(SellerProductFormModal, {
          key: 0,
          "product-code": formCode.value,
          persistent: !formCode.value,
          "initial-mall-kind": 'REGULAR',
          onClose: closeForm,
          onSaved: onFormSaved
        }, null, 8, ["product-code", "persistent"]))
      : _createCommentVNode("", true),
    (previewCode.value)
      ? (_openBlock(), _createBlock(ManageProductStorefrontModal, {
          key: 1,
          code: previewCode.value,
          audience: "seller",
          "mall-open": previewMallOpen.value,
          "initial-tab": previewTab.value,
          onClose: closePreview
        }, null, 8, ["code", "mall-open", "initial-tab"]))
      : _createCommentVNode("", true),
    (ratingInsight.value)
      ? (_openBlock(), _createBlock(ProductRatingModal, {
          key: 2,
          "product-code": ratingInsight.value.code,
          "product-name": ratingInsight.value.name,
          rating: ratingInsight.value.rating,
          "review-count": ratingInsight.value.reviewCount,
          onClose: _cache[23] || (_cache[23] = ($event: any) => (ratingInsight.value = null))
        }, null, 8, ["product-code", "product-name", "rating", "review-count"]))
      : _createCommentVNode("", true),
    (viewsInsight.value || viewsMenuOpen.value)
      ? (_openBlock(), _createBlock(ProductViewsInsightModal, {
          key: 3,
          "product-code": viewsInsight.value?.code || '',
          "product-name": viewsInsight.value?.name || '',
          views: viewsInsight.value?.views || 0,
          "sold-count": viewsInsight.value?.soldCount || 0,
          candidates: viewsMenuOpen.value ? modalCandidates.value : [],
          onClose: closeViews,
          onSelect: onPickViews,
          onPreview: openPreviewFromViews
        }, null, 8, ["product-code", "product-name", "views", "sold-count", "candidates"]))
      : _createCommentVNode("", true),
    (stockHistoryCode.value || stockMenuOpen.value)
      ? (_openBlock(), _createBlock(ProductStockHistoryModal, {
          key: 4,
          "product-code": stockHistoryCode.value,
          "product-name": stockHistoryName.value,
          candidates: stockMenuOpen.value ? modalCandidates.value : [],
          audience: "seller",
          onClose: closeStockHistory,
          onSelect: onPickStock,
          onUpdated: onStockUpdated
        }, null, 8, ["product-code", "product-name", "candidates"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "sui-toast" }, {
      default: _withCtx(() => [
        (toast.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_64, [
              _createVNode(AppIcon, {
                icon: "mdi-check-circle",
                size: 18
              }),
              _createTextVNode(" " + _toDisplayString(toast.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})